import { useMediaQuery } from 'react-responsive'
import { ICardLocation } from '../../interfaces';
import Schedule from './Schedule';
import Address from './Address';
import TabAction from './TabAction';
import Button from '../main/Button';
import Map from './Map';
import Icon from '../main/Icon';
import '../styles/CardLocation.css';
import '../../utils/GlobalStyles.css';

function CardLocation({ name, base64TeamLogo, address, openingHours } : ICardLocation) 
{
    const isMobile = useMediaQuery({ query: '(width <= 700px)' });
    
    return (
        <div className = 'centered'>
            <div
                className = 'card-container shadow'
                style = {{ display: 'flex', flexDirection: 'column', gap: '15px' }}
            >
                <div className = 'row'>
                    <TabAction
                        icon = {<Icon icon = {'location-dot'} size = '20px'/>}
                        text = 'Standort'
                    />

                    <Button
                        buttonText = 'Navigation'
                        spacing = {6}
                        rigthIcon = 
                        {
                            <Icon 
                                icon = 'location-arrow'
                                color = {sessionStorage.getItem('primaryColor') as string}
                                size = {'18px'}
                            />
                        }
                        size = 'small'
                        type = 'link'
                        onClick={() => {
                            const destination = `${address.street} ${address.houseNumber}, ${address.zip} ${address.city}`;
                            
                            // Get browser locale and determine Google Maps domain
                            const locale = navigator.language.toLowerCase();
                            let mapsHost = 'www.google.com';
                            
                            if (locale.startsWith('de')) {
                                mapsHost = 'www.google.de';
                            } else if (locale.startsWith('fr')) {
                                mapsHost = 'www.google.fr';
                            } else if (locale.startsWith('es')) {
                                mapsHost = 'www.google.es';
                            } else if (locale.startsWith('it')) {
                                mapsHost = 'www.google.it';
                            } else if (locale.startsWith('nl')) {
                                mapsHost = 'www.google.nl';
                            } else if (locale.startsWith('pl')) {
                                mapsHost = 'www.google.pl';
                            } else if (locale.startsWith('pt')) {
                                mapsHost = 'www.google.com.br';
                            } else if (locale.startsWith('ru')) {
                                mapsHost = 'www.google.ru';
                            } else if (locale.startsWith('ja')) {
                                mapsHost = 'www.google.co.jp';
                            } else if (locale.startsWith('ko')) {
                                mapsHost = 'www.google.co.kr';
                            } else if (locale.startsWith('zh')) {
                                mapsHost = 'www.google.com.hk';
                            }
                            
                            const googleMapsUrl = `https://${mapsHost}/maps/dir/?api=1&destination=${encodeURIComponent(destination)}`;
                            window.open(googleMapsUrl, '_blank');
                        }}
                    />
                </div>
                
                <div 
                    className = 'row'
                    style = {isMobile ? { flexDirection: 'column' } : {}}
                >
                    <div
                        className = {isMobile ? 'schedule' : ''}
                        style = {{ display: 'flex', flexDirection: 'column', gap: '20px' }}
                    >
                        {base64TeamLogo && (
                          <div style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            width: '100%',
                            maxWidth: '200px',
                            height: '80px'
                        }}>
                            {/* base64TeamLogo ist eine volle data:-URI (korrekte MIME, inkl. SVG). */}
                            <img
                                src = {base64TeamLogo}
                                alt = 'Brand'
                                style={{
                                    maxWidth: '100%',
                                    maxHeight: '100%',
                                    objectFit: 'contain',
                                    objectPosition: 'center'
                                }}
                            />
                        </div>
                        )}

                        <Address 
                            {...{ ...address }}
                            team = {name}
                        />

                        <Schedule {...{ openingHours }} />
                    </div>

                    <div className = 'map'>
                        <Map 
                            latitude = {+address.latitude}
                            longtitude = {+address.longtitude}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CardLocation;